export default {
  space: [0, 8, 16, 24, 32, 48, 64, 96, 128, 256, 512]
};
